import { Routes } from '@angular/router';
import { IndexComponent } from './index.component';
import { PresentationComponent } from '../presentation/presentation.component';
import { EstablishmentMainComponent } from '../establishment-main/establishment-main.component';
import { DetailOrdenCheckoutComponent } from '../detail-orden-checkout/detail-orden-checkout.component';
import { OrdersUserComponent } from '../orders-user/orders-user.component';
import { DetailOrderComponent } from '../orders-user/detail-order/detail-order.component';
import { PERFIL_USER_ROUTES } from '../perfil-user/perfil-user.routes';
import { EstablishmentsForCategorieComponent } from '../establishments-for-categorie/establishments-for-categorie.component';
import { EstablishmentsGralComponent } from '../establishments-gral/establishments-gral.component';
import { EstablishmentsAllComponent } from '../establishments-all/establishments-all.component';

export const indexRoutes: Routes = [
  {
    path: '',
    component: IndexComponent,
    children: [
      {
        path: '',
        component: PresentationComponent,
        pathMatch: 'full'
      },
      {
        path: 'products-establishment/:id/:slug',
        component: EstablishmentMainComponent,
        data: {
          renderMode: 'browser'
        }

      },
      {
        path: 'products-establishment/:id',
        component: EstablishmentMainComponent,
        data: {
          renderMode: 'browser'
        }
      },
      {
        path: 'auth/detail-orden-payment',
        component: DetailOrdenCheckoutComponent
      },
      {
        path: 'auth/orders',
        component: OrdersUserComponent
      },
      {
        path: 'auth/order/:id',
        component: DetailOrderComponent,
        data: {
          renderMode: 'browser'
        }
      },
      {
        path: 'auth/perfil',
        children: PERFIL_USER_ROUTES
      },
      {
        path: 'establishments-categorie',
        component: EstablishmentsForCategorieComponent
      },
      {
        path: 'establishments-location',
        component: EstablishmentsAllComponent
      },

      {
        path: 'establishments-categorie/:id',
        component: EstablishmentsForCategorieComponent
      },

      {
        path: 'establishment-section-gral',
        component: EstablishmentsGralComponent
      },

      {
        path: 'establishment-section-gral/:id',
        component: EstablishmentsGralComponent
      },


      {
        path: '**',
        component: PresentationComponent
      }
    ]
  }
];
